export const BACK_TO_MY_ORDERS_LINK_TEXT = 'Back to my orders';
export const MY_ACCOUNT_ORDER_URL = '/Account/LoginRedirect.aspx?tabId=12';
export const ORDER_LISTING_URL = '/my-account/apps/order-tracker/orders';
